import React, { ComponentProps } from 'react';
import { Link as RouterLink } from 'react-router';
import { useMaxViewport } from '../../core/hooks/use-max-viewport';
import { ImageTransformType, ImageType } from '../../modules/image/constants';
import { Image } from '../../modules/image/image';
import { Icon } from '../icon/icon';
import { ProductLine } from '../product-line/product-line';
import { Typography } from '../typography/typography';
import styles from './teaser-card.module.scss';

type Props = {
  seriesDescription: string;
  imgSrc: string;
  detailsLink: string;
} & Omit<ComponentProps<typeof ProductLine>, 'variant'>;

export const TeaserCard: React.FC<Props> = ({
  series,
  seriesNumber,
  seriesDescription,
  seriesNumberColor,
  imgSrc,
  detailsLink,
}) => {
  const isMobile = useMaxViewport('xs');

  return (
    <RouterLink className={styles.root} referrerPolicy="no-referrer" target="_blank" to={detailsLink}>
      <div className={styles.imageContainer}>
        <Image
          baseSrc={imgSrc}
          className={styles.image}
          imageSizes={ImageTransformType.teaserCardImg}
          type={isMobile ? ImageType.aspectRatio : ImageType.fillContainer}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.productInformation}>
          <ProductLine
            series={series}
            seriesNumber={seriesNumber}
            seriesNumberColor={seriesNumberColor}
            variant="big"
          />
          <Typography variant="maintext">{seriesDescription}</Typography>
        </div>
        <Icon className={styles.linkIcon} size="24" variant="arrow-up-right" />
      </div>
    </RouterLink>
  );
};
